/* eslint-disable */
// @ts-nocheck
export function initHeroControls() {
  function closeAll(except) {
    document.querySelectorAll('#hero .hero-dd').forEach(function (dd) {
      if (dd === except || dd.id === 'hero-dd-sample-wrap') return
      dd.classList.remove('open')
      var pop = dd.querySelector('.hero-dd-pop')
      if (pop) pop.hidden = true
      var tr = dd.querySelector('.hero-dd-trigger')
      if (tr) tr.setAttribute('aria-expanded', 'false')
    })
  }
  function bindDropdown(wrapId, onPick) {
    var wrap = document.getElementById(wrapId)
    if (!wrap) return
    var trigger = wrap.querySelector('.hero-dd-trigger')
    var pop = wrap.querySelector('.hero-dd-pop')
    if (trigger)
      trigger.addEventListener('click', function (e) {
        e.stopPropagation()
        if (wrap.classList.contains('open')) closeAll()
        else {
          closeAll(wrap)
          wrap.classList.add('open')
          if (pop) pop.hidden = false
          trigger.setAttribute('aria-expanded', 'true')
        }
      })
    wrap.querySelectorAll('.hero-dd-opt').forEach(function (opt) {
      opt.addEventListener('mousedown', function (e) {
        e.preventDefault()
      })
      opt.addEventListener('click', function (e) {
        e.stopPropagation()
        onPick(opt, wrap)
        closeAll()
      })
    })
  }
  var HERO_PRODUCT_IMAGES = window.__COST_BOM_PRODUCT_IMAGES__ || {}
  window.setHeroProductImage = function (product) {
    var img = document.getElementById('hero-product-visual')
    if (!img) return
    var src = HERO_PRODUCT_IMAGES[product]
    if (src) {
      if (img.getAttribute('src') !== src) img.setAttribute('src', src)
      img.setAttribute('data-product', product)
      img.classList.remove('is-shown')
      img.style.animation = 'none'
      void img.offsetWidth
      img.style.animation = ''
      img.classList.add('is-shown')
    } else {
      img.classList.remove('is-shown')
    }
  }
  var HERO_PHASE_MSG = {
    search: 'Understanding your product…',
    breakdown: 'Breaking down to components…',
    manufacturing: 'Predicting manufacturing steps…',
    sourcing: 'Predicting sourcing…',
    costing: 'Layering cost intelligence…',
    ready: 'Your cost model is ready',
  }
  window.updateHeroBuildingStatus = function (phase) {
    var txt = document.getElementById('hero-gen-status-txt')
    if (txt) txt.textContent = HERO_PHASE_MSG[phase] || HERO_PHASE_MSG.search
  }
  window.expandHeroBrowser = function () {
    var hero = document.getElementById('hero')
    if (hero && hero.getAttribute('data-hero-phase') === 'generating')
      hero.setAttribute('data-hero-browser', 'expanded')
  }
  window.heroStartGenerate = function () {
    var hero = document.getElementById('hero')
    if (!hero || hero.getAttribute('data-hero-phase') === 'generating') return
    var pin = document.getElementById('hero-dd-product')
    var cin = document.getElementById('hero-dd-country')
    var product = (pin && pin.value) || 'NMC Battery Cell'
    var country = (cin && cin.value) || 'China'
    var sampleMap = {
      'NMC Battery Cell': 'nmc',
      'Citric Acid': 'citric',
      'Smart Home SoC': 'soc',
    }
    var sampleKey = sampleMap[product] || 'nmc'
    window.heroUseSampleReveal = true
    window.heroPendingSampleKey = sampleKey
    hero.setAttribute('data-hero-phase', 'generating')
    if (
      hero.classList.contains('hero-cta-unlocked') &&
      window.scheduleHeroTabCta
    )
      window.scheduleHeroTabCta()
    window.updateHeroBuildingStatus('search')
    var tabsBar = document.getElementById('cm2-tabs')
    if (tabsBar) tabsBar.hidden = false
    closeHeroTabAddPop()
    var genBtn = document.getElementById('hero-generate-btn')
    if (genBtn) {
      genBtn.disabled = true
      genBtn.textContent = 'Generating…'
    }
    var browser = document.getElementById('cm2-inline-browser')
    if (browser) browser.scrollIntoView({ behavior: 'smooth', block: 'center' })
    if (window.heroGenerateSample) window.heroGenerateSample(sampleKey)
    if (window.cm2BuildTab) window.cm2BuildTab(product, country)
  }
  var genBtn = document.getElementById('hero-generate-btn')
  if (genBtn)
    genBtn.addEventListener('click', function () {
      if (window.heroStartGenerate) window.heroStartGenerate()
    })
  document.addEventListener('click', function () {
    closeAll()
    if (window.closeHeroTabAddPop) window.closeHeroTabAddPop()
  })
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAll()
      if (window.closeHeroTabAddPop) window.closeHeroTabAddPop()
    }
  })

  var heroTabCtaWrap = document.getElementById('hero-tab-cta-wrap')
  // Find OUR CTA by its unique class, not the id. The Should-Cost landing page
  // has its own element with id="build-cost-model" (the old, retired button),
  // so document.getElementById would grab that one and our CTA would get no
  // click handler. The id stays on our button only for GTM's click trigger.
  var heroTabCtaBtn = document.querySelector('#hero .hero-tab-cta')

  function unlockHeroTabCta() {
    var hero = document.getElementById('hero')
    if (hero) hero.classList.add('hero-cta-unlocked')
    if (heroTabCtaWrap) heroTabCtaWrap.hidden = false
  }
  function revealHeroTabCta() {
    if (!heroTabCtaWrap) return
    unlockHeroTabCta()
  }
  function hideHeroTabCta(reset) {
    var hero = document.getElementById('hero')
    if (reset) {
      if (hero) hero.classList.remove('hero-cta-unlocked')
      if (heroTabCtaBtn) {
        heroTabCtaBtn.classList.remove('is-submitted')
        heroTabCtaBtn.disabled = false
        var lbl = heroTabCtaBtn.querySelector('span')
        if (lbl) lbl.textContent = 'Build Your Own Cost Model'
      }
    }
    if (heroTabCtaWrap) heroTabCtaWrap.hidden = true
  }
  window.hideHeroTabCta = hideHeroTabCta
  function scheduleHeroTabCta() {
    revealHeroTabCta()
  }
  window.scheduleHeroTabCta = scheduleHeroTabCta

  // The conversion form itself (open/close, validation, submit, success) is a
  // React component (HeroConversionModal). This CTA just asks React to open it.
  if (heroTabCtaBtn) {
    heroTabCtaBtn.addEventListener('click', function (e) {
      e.stopPropagation()
      if (heroTabCtaBtn.disabled) return
      if (window.openHeroConversionModal) window.openHeroConversionModal()
    })
  }
}
